// App.tsx — sovereign entry point
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./Home";
import CherishedLegacyHolding from "./CherishedLegacyHolding";
import Director from "./src/pages/Director";

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <h1 className="text-4xl font-serif font-semibold text-stone-800 mb-2">404</h1>
        <p className="text-stone-500">Page not found.</p>
      </div>
    </div>
  );
}

function Router() {
  const isCherishedLegacy =
    typeof window !== "undefined" &&
    window.location.hostname.includes("cherishedlegacy");

  return (
    <Routes>
      <Route path="/" element={isCherishedLegacy ? <CherishedLegacyHolding /> : <Home />} />
      <Route path="/b2b" element={<CherishedLegacyHolding />} />
      <Route path="/director" element={<Director />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Router />
    </BrowserRouter>
  );
}
